import { render } from "./BaseButton.vue?vue&type=template&id=35d06e62&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=35d06e62&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35d06e62"

export default script